import { useState } from 'react';
import { motion } from 'framer-motion';

const DemoReel = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <section id="demo-reel" className="py-24 bg-gradient-to-b from-cream to-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Video Player */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl bg-black aspect-video w-full h-full">
              {!isPlaying ? (
                <>
                  <img
                    src="https://public.readdy.ai/ai/img_res/3896dfcbc21808ebb58cdec5c3993c2e.jpg"
                    alt="Demo Reel Thumbnail"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                    <button
                      onClick={() => setIsPlaying(true)}
                      className="w-20 h-20 flex items-center justify-center bg-white rounded-full hover:scale-110 transition-transform duration-300 cursor-pointer shadow-xl"
                    >
                      <i className="ri-play-fill text-4xl text-black ml-1"></i>
                    </button>
                  </div>
                </>
              ) : (
                <iframe
                  src="https://player.vimeo.com/video/1166964995?autoplay=1&title=0&byline=0&portrait=0"
                  className="w-full h-full"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  title="Demo Reel"
                ></iframe>
              )}
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="uppercase text-xs tracking-widest text-burgundy font-semibold mb-4">
              Featured Work
            </div>
            <h2 className="font-serif text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Demo Reel 2025
            </h2>
            <p className="text-gray-700 text-lg leading-relaxed mb-8">
              A curated showcase of my most compelling performances across film and television. This reel demonstrates my range, from intense dramatic moments to nuanced character work, highlighting my versatility and commitment to authentic storytelling.
            </p>
            <div className="flex gap-4">
              <a
                href="https://vimeo.com/1166964995"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-3 bg-black text-white rounded-full font-medium hover:bg-gray-800 transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                Watch on Vimeo
              </a>
              <button className="px-8 py-3 border-2 border-black text-black rounded-full font-medium hover:bg-black hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap">
                Full Credits
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default DemoReel;